import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-windows\"><defs><style type=\"text/css\"></style></defs><path d=\"M426.285714 574.857143l0 372-389.714286-53.714286 0-318.285714 389.714286 0zm0-424.571429l0 376.571429-389.714286 0 0-322.857143zm561.142857 424.571429l0 449.142857-518.285714-71.428571 0-377.714286 518.285714 0zm0-501.714286l0 453.714286-518.285714 0 0-382.285714z\" p-id=\"6922\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/windows.svg
// module id = FhIN
// module chunks = 1